import Highcharts from 'highcharts';
import { filterByCategory } from '../ranking-sm/data.js';

export function getMandatyFinanse() {
    const categories = [
        'Mandaty: liczba wystawionych',
        'Etaty: liczba strażników',
        'Budżet',
        'Mandaty: wartość',
        'Mandaty: liczba wystawionych dot. PRD',
        'Mandaty: wartość wystawionych dot. PRD'
    ];
    const data = filterByCategory(categories);

    const validData = data.filter(sm =>
        sm['Mandaty: liczba wystawionych'] !== null &&
        sm['Etaty: liczba strażników'] !== null &&
        sm['Budżet'] !== null &&
        sm['Mandaty: wartość'] !== null &&
        typeof sm['Mandaty: liczba wystawionych'] === 'number' &&
        typeof sm['Etaty: liczba strażników'] === 'number' &&
        typeof sm['Budżet'] === 'number' &&
        typeof sm['Mandaty: wartość'] === 'number'
    );

    validData.forEach(sm => {
        sm.finesPerGuardMonthly = Math.round((sm['Mandaty: liczba wystawionych'] / sm['Etaty: liczba strażników'] / 12) * 10) / 10;
        sm.selfFinancingRate = Math.round((sm['Mandaty: wartość'] / sm['Budżet']) * 100 * 10) / 10;
        if (sm['Mandaty: wartość wystawionych dot. PRD'] && sm['Mandaty: liczba wystawionych dot. PRD']) {
            sm.avgPrdFine = Math.round(sm['Mandaty: wartość wystawionych dot. PRD'] / sm['Mandaty: liczba wystawionych dot. PRD']);
        } else {
            sm.avgPrdFine = null;
        }
    });

    return validData.sort((a, b) => b.finesPerGuardMonthly - a.finesPerGuardMonthly);
}

export default function chartFinesStructure(id) {
    if (!document.getElementById(id)) return;

    const data = getMandatyFinanse();

    const chartData = data
        .filter(sm =>
            sm['Mandaty: liczba wystawionych dot. PRD'] != null &&
            sm['Mandaty: liczba wystawionych'] > 0
        )
        .map(sm => ({
            city: sm.city,
            prdPercent: Math.round(
                (sm['Mandaty: liczba wystawionych dot. PRD'] / sm['Mandaty: liczba wystawionych']) * 1000
            ) / 10
        }))
        .sort((a, b) => b.prdPercent - a.prdPercent);

    const categories = chartData.map(d => d.city);
    const prdPercents = chartData.map(d => d.prdPercent);
    const avg = 76;

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Share of traffic fines (PRD) in total fines' },
        xAxis: {
            categories: categories,
            title: { text: null },
            labels: { style: { fontSize: '14px' } }
        },
        yAxis: {
            title: { text: 'Share of traffic fines' },
            min: 0,
            max: 100,
            labels: { format: '{value}%' },
            gridLineWidth: 1,
            plotLines: [{
                value: avg,
                color: '#2c3e50',
                dashStyle: 'ShortDash',
                width: 1,
                label: {
                    text: `Average: ${avg}%`,
                    align: 'right',
                    verticalAlign: 'bottom',
                    style: { color: '#2c3e50', fontWeight: 'bold' }
                }
            }]
        },
        legend: { enabled: false },
        tooltip: {
            formatter: function () {
                return `<b>${this.x}</b><br/>Traffic fines: <b>${this.y}%</b>`;
            }
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    format: '{y}%',
                    style: { fontSize: '11px', textOutline: 'none' }
                }
            },
            series: { borderWidth: 0 }
        },
        credits: { enabled: false },
        series: [{
            name: 'Traffic fine share',
            color: '#FFFF00',
            data: prdPercents.map(d => ({
                y: d,
                color: d > avg ? '#cb3d20ff' : '#cb9520'
            }))
        }]
    });
}
